import React, { useState } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot';

const THEME = {
    primary: '#1F2937',
    secondary: '#8B5CF6', // Un tono violeta para comunicación
    success: '#10B981',
    danger: '#EF4444',
    bg: '#F3F4F6',
    white: '#FFFFFF',
    border: '#E5E7EB'
};

function AdminBroadcast() {
    const [form, setForm] = useState({ asunto: '', mensaje: '' });
    const [loading, setLoading] = useState(false);

    const handleSend = async (e) => {
        e.preventDefault();
        if(!window.confirm("⚠️ ¿Estás seguro de enviar este correo a TODOS los clientes activos?\n\nEsta acción no se puede deshacer.")) return;
        
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            // Ajusta la ruta si tu backend tiene un prefijo diferente
            await api.post('/users/admin/broadcast', form, { 
                headers: { Authorization: `Bearer ${token}` }
            });
            
            alert('✅ Anuncio enviado correctamente a la base de clientes.');
            setForm({ asunto: '', mensaje: '' }); // Limpiar formulario

        } catch (error) {
            console.error(error);
            alert('❌ Error al enviar el anuncio. Revisa la consola o el backend.');
        } finally {
            setLoading(false);
        }
    };

    // Estilos
    const cardStyle = { 
        background: THEME.white, 
        padding: 40, 
        borderRadius: 12, 
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', 
        maxWidth: 700, 
        margin: '0 auto',
        borderTop: `6px solid ${THEME.secondary}`
    };
    
    const labelStyle = { fontWeight: 'bold', display: 'block', marginBottom: 8, color: THEME.primary };
    const inputStyle = { 
        width: '100%', 
        padding: 12, 
        marginBottom: 20, 
        borderRadius: 8, 
        border: `1px solid ${THEME.border}`,
        fontSize: 14,
        background: '#FAFAFA'
    };

    return (
        <AdminLayout title="📢 Comunicación Masiva">
            
            <div style={{ maxWidth: 800, margin: '0 auto' }}>
                
                {/* Info Box */}
                <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', padding: 15, borderRadius: 8, marginBottom: 30, color: '#1E40AF', fontSize: 14, display: 'flex', gap: 10 }}>
                    <span style={{ fontSize: 20 }}>ℹ️</span>
                    <div>
                        <strong>Aviso Importante:</strong>
                        <p style={{ margin: '5px 0 0 0', opacity: 0.9 }}>
                            Esta herramienta enviará un correo electrónico a <b>todos los usuarios con rol "Cliente"</b> que estén activos en la plataforma. Úsala para avisos de vacaciones, cambios de precios o promociones generales.
                        </p>
                    </div>
                </div>

                <div style={cardStyle}>
                    <h2 style={{ color: THEME.primary, marginTop: 0, marginBottom: 10, fontSize: 22 }}>Redactar Anuncio</h2>
                    <p style={{ color: '#6B7280', marginBottom: 30, fontSize: 14 }}>El mensaje se enviará con el formato oficial de Xavana.</p>
                    
                    <form onSubmit={handleSend}>
                        
                        <label style={labelStyle}>Asunto del Correo</label>
                        <input 
                            type="text" 
                            value={form.asunto} 
                            onChange={e => setForm({...form, asunto: e.target.value})} 
                            style={inputStyle} 
                            placeholder="Ej: Aviso importante sobre pedidos de fin de año" 
                            required
                        />

                        <label style={labelStyle}>Mensaje</label>
                        <textarea 
                            value={form.mensaje} 
                            onChange={e => setForm({...form, mensaje: e.target.value})} 
                            style={{...inputStyle, minHeight: 200, fontFamily: 'sans-serif', lineHeight: 1.5}} 
                            placeholder="Escribe aquí el contenido detallado..." 
                            required
                        />

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button 
                                type="submit" 
                                disabled={loading}
                                style={{ 
                                    padding: '12px 30px', 
                                    background: loading ? '#9CA3AF' : THEME.secondary, 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: 8, 
                                    fontWeight: 'bold', 
                                    fontSize: 15,
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                    transition: '0.2s'
                                }}
                            >
                                {loading ? '🚀 Enviando correos...' : 'Enviar Anuncio Masivo'}
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </AdminLayout>
    );
}

export default AdminBroadcast;